/**
 * MUI theme for the Taiken calendar.
 *
 * Brand colours and the repeated control styling live here rather than being
 * re-declared through `sx` on every element.
 */

import { createTheme } from '@mui/material/styles';

export const BRAND = {
    green: '#4A6B5D',
    greenDark: '#3D594D',
    sand: '#F4F1EA',
    moss: '#7B9A7D',
    clay: '#B9825A',
    ink: '#2F3A35',
};

export const createTaikenTheme = () =>
    createTheme({
        palette: {
            primary: { main: BRAND.green, dark: BRAND.greenDark, contrastText: '#fff' },
            secondary: { main: BRAND.clay, contrastText: '#fff' },
            background: { default: BRAND.sand, paper: '#fff' },
            text: { primary: BRAND.ink, secondary: 'rgba(47,58,53,0.78)' },
        },
        typography: {
            fontFamily: [
                '"Noto Sans JP"',
                '"Hiragino Kaku Gothic ProN"',
                '"Hiragino Sans"',
                'Meiryo',
                'sans-serif',
            ].join(','),
            button: { textTransform: 'none', fontWeight: 700 },
        },
        shape: { borderRadius: 8 },
        components: {
            MuiToggleButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                        fontWeight: 700,
                        color: BRAND.green,
                        borderColor: 'rgba(74,107,93,0.25)',
                        paddingInline: 14,
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(74,107,93,0.14)',
                            color: BRAND.greenDark,
                            '&:hover': { backgroundColor: 'rgba(74,107,93,0.2)' },
                        },
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    outlined: { borderColor: 'rgba(74,107,93,0.2)' },
                },
            },
            MuiChip: {
                styleOverrides: {
                    root: { fontWeight: 600 },
                },
            },
        },
    });
